module.exports = __webpack_public_path__ + "img/enemy_112_001.72274835.png";